const DEFAULT_SEARCH_ORDER = 'relevance';

export { DEFAULT_SEARCH_ORDER };
